"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OtherCatalogues = void 0;
var _presentationComponents = require("@ori/presentation-components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _times = _interopRequireDefault(require("es-toolkit/compat/times"));
var _contexts = require("../../contexts");
var _useTranslations = require("../../hooks/useTranslations");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const OtherCatalogues = ()=>{
    const { getTestId } = (0, _testidGenerator.default)();
    const { translations } = (0, _useTranslations.useTranslations)();
    const { data, loading } = (0, _contexts.useCataloguesLandingPageContext)();
    if (loading || !data) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Root, {
            "data-testid": getTestId(_constants.OTHER_CATALOGUES_SKELETON),
            children: (0, _times.default)(_constants.COUNT_OF_CATALOGUE_SKELETONS).map((_, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_presentationComponents.CategoryBoxSkeleton, {
                    showDescription: true,
                    animation: loading ? 'pulse' : false,
                    size: _presentationComponents.CategoryBoxSize.MEDIUM
                }, "".concat(_presentationComponents.CATEGORY_BOX_SKELETON, "-").concat(index)))
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Root, {
        "data-testid": getTestId(_constants.OTHER_CATALOGUES),
        children: data.otherCatalogues.map((catalogue)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_presentationComponents.CategoryBox, {
                buttonText: translations.view,
                description: catalogue.validity,
                imageUrl: catalogue.imageUrl,
                relativeUrl: catalogue.link,
                title: catalogue.title,
                size: _presentationComponents.CategoryBoxSize.MEDIUM
            }, catalogue.link))
    });
};
exports.OtherCatalogues = OtherCatalogues;
